import type { ProfileDataResult } from "api-contracts/rpc/profile-data";
import type { AuthToken, AuthUser } from "api-contracts/rpc/auth";

type Profile = Partial<AuthToken & AuthUser & ProfileDataResult>;

export function isFan(profileData?: Profile | null): boolean {
  if (!profileData) return false;

  if (minimalViableCreator(profileData)) return false;
  if (profileData.handle) return false;
  if (profileData?.profileImageUrl) return false;
  if (profileData?.avatarUrl) return false;

  return true;
}

export function minimalViableCreator(profileData?: Profile | null): boolean {
  if (!profileData) return false;

  if (!profileData.handle) return false;
  if (!(profileData?.profileImageUrl || profileData?.avatarUrl)) return false;
  // NOTE: throws user in onboarding when they have a video
  // if (!profileData.backgroundImageUrl) return false;

  // NOTE: disabled to make auth token and auth user pass as creators
  // if (profileData?.socialLinks && profileData.socialLinks.length === 0) return false;
  // if (!(profileData.theme?.id || profileData.customColors)) return false;

  return true;
}
